import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import Select from 'react-select';

// Components
import Loader from '../../utils/Loader';
import Modal from '../../modal/Modal';
import Button from '../../modal/Button';
import BillingAddressModal from './BillingAddressModal';

// State
import { getLocations, getProvinces } from '../../../store/actions/locations';
import {
    setBilling,
    setSavedBillingAddress,
    setActiveCheckoutSection,
} from '../../../store/actions/checkout';

// CSS
import '../../../css/custom-checkbox.css';
import '../../../css/shipping-form.css';
import '../../../css/react-select.css';

// Util
import {
    setCheckoutSectionActive as setCheckoutSectionActiveGA,
    setCheckoutSectionComplete as setCheckoutSectionCompleteGA,
} from '../../../utils/google-analytics';

class BillingSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddressModal: false,
            fname: !!props.billing.fname ? props.billing.fname : '',
            lname: !!props.billing.lname ? props.billing.lname : '',
            company: !!props.billing.company ? props.billing.company : '',
            address: !!props.billing.address ? props.billing.address : '',
            address_2: !!props.billing.address_2 ? props.billing.address_2 : '',
            city: !!props.billing.city ? props.billing.city : '',
            postal: !!props.billing.postal ? props.billing.postal : '',
            country: !!props.billing.country ? props.billing.country : '',
            province: !!props.billing.province ? props.billing.province : '',
            phone: !!props.billing.phone ? props.billing.phone : '',
            save_address: !!props.billing.id ? props.billing.id : '',
        };
    }

    // ===================================
    //  LIFE CYCLE HOOKS
    // ===================================
    componentDidMount() {
        this.props.getLocations();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.default_country !== null && this.state.country === '') {
            this.setState({
                country: nextProps.default_country,
            });
        }
    }

    // ===================================
    //  INPUT
    // ===================================
    updateSelectedCountry = (country) => {
        this.setState(
            {
                country: country.id,
                province: '',
            },
            () => this.props.getProvinces(this.state.country)
        );
    };

    updateSelectedProvince = (province) => {
        this.setState({ province: province.abbreviation });
    };

    handleInputChange(event) {
        this.setState({
            [event.target.id]: event.target.value,
        });
    }

    handleKeyPress(event, item_id) {
        if (event.key === 'Enter') {
            this.handleSubmit(event);
        }
    }

    handleNumberChange(id, valueObject) {
        this.setState({
            [id]: valueObject.value,
        });
    }

    handleCheckboxClick(event) {
        const { id } = event.target;
        this.setState({
            [id]: !this.state[id],
        });
    }

    // ===================================
    //  SUBMIT
    // ===================================
    handleSubmit(event) {
        event.preventDefault();
        this.props.setBilling(this.state).then((resp) => {
            if (resp !== undefined) {
                // Set current section as complete
                setCheckoutSectionCompleteGA(5);
                const skip_shipping_location =
                    this.props.isStore &&
                    !!this.props.shippingData.skip_shipping_location;
                const allow_pickup_times =
                    this.props.isStore && this.props.allowPickupTimes;
                const skip_shipping_method = this.props.isStore;

                // So we want both of these skips to be true to run pickup
                // Which is semi-confusing because want it to be false in CheckoutMain so the option will show
                if (
                    skip_shipping_location &&
                    skip_shipping_method &&
                    allow_pickup_times
                ) {
                    // Set pickup active
                    setCheckoutSectionActiveGA(5.5);
                    this.props.setActiveCheckoutSection('pickup');
                } else {
                    // setCheckoutSectionCompleteGA(5.5);
                    // Set Shipping Payment active
                    setCheckoutSectionActiveGA(6);
                    this.props.setActiveCheckoutSection('order');
                }
            }
        });
    }

    handleSavedBillingAddressSelect = (billingData) => {
        this.setState({ showAddressModal: false });
        this.props.setSavedBillingAddress(billingData);

        const skip_shipping_location =
            this.props.isStore && !!this.props.shippingData.skip_shipping_location;
        const allow_pickup_times = this.props.isStore && this.props.allowPickupTimes;
        const skip_shipping_method = this.props.isStore;

        // Set current section as complete
        setCheckoutSectionCompleteGA(5);

        // So we want both of these skips to be true to run pickup
        // Which is semi-confusing because want it to be false in CheckoutMain so the option will show
        if (skip_shipping_location && skip_shipping_method && allow_pickup_times) {
            // Set pickup active
            setCheckoutSectionActiveGA(5.5);
            this.props.setActiveCheckoutSection('pickup');
        } else {
            setCheckoutSectionCompleteGA(5.5);
            // Set Order active
            setCheckoutSectionActiveGA(6);
            this.props.setActiveCheckoutSection('order');
        }

        // Set Order active
        // setCheckoutSectionActiveGA(6);
        // this.props.setActiveCheckoutSection("order");
    };

    render() {
        const {
            user,
            billing,
            countries,
            provinces,
            errors,
            locationsError,
            locationsLoading,
        } = this.props;

        var notGuest =
            user.customer && Object.keys(user.customer.user).length ? true : false;

        return (
            <div>
                <div className="delivery-heading">
                    <h2>Enter a Billing Address:</h2>

                    {notGuest && (
                        <div>
                            <div
                                className={'btn btn--red btn--heading'}
                                disabled={this.props.billingCheckInProgress}
                                onClick={() => this.setState({ showAddressModal: true })}
                            >
                                Choose Saved Address
                            </div>

                            {/* ADDRESS MODAL */}
                            {this.state.showAddressModal && (
                                <Modal
                                    title={'Choose Address'}
                                    buttons={[
                                        {
                                            type: Button,
                                            text: 'Close',
                                            action: () =>
                                                this.setState({
                                                    showAddressModal: false,
                                                }),
                                            disabled: this.props.deleteInProcess,
                                        },
                                    ]}
                                >
                                    <BillingAddressModal
                                        handleSelect={
                                            this.handleSavedBillingAddressSelect
                                        }
                                    />
                                </Modal>
                            )}
                        </div>
                    )}

                    {!!billing && billing.delivery_id && (
                        <div className="form-field half-field same-billing-checkbox-field">
                            <div
                                className={'custom-label checkbox-label no-bottom-margin'}
                            >
                                <input
                                    type="checkbox"
                                    id="same_billing"
                                    name="same_billing"
                                    value="1"
                                    checked={billing.same_billing}
                                />
                                <label htmlFor="same_billing">Same as Shipping</label>
                            </div>
                        </div>
                    )}
                </div>

                <form className="shipping-form tight-form-fields">
                    {!!billing && billing.id && (
                        <input type="hidden" name="id" value={billing.id} />
                    )}

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="fname">First Name:</label>

                            {!!errors.fname && (
                                <div className="error">{errors.fname}</div>
                            )}

                            <input
                                type="text"
                                name="fname"
                                id="fname"
                                value={this.state.fname}
                                placeholder="First Name"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>

                        <div className="form-field no-label-field half-field">
                            <label htmlFor="lname">Last Name:</label>

                            {!!errors.lname && (
                                <div className="error">{errors.lname}</div>
                            )}

                            <input
                                type="text"
                                name="lname"
                                id="lname"
                                value={this.state.lname}
                                placeholder="Last Name"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>
                    </div>

                    <div className="form-field no-label-field">
                        <label htmlFor="password">Company:</label>

                        {!!errors.company && (
                            <div className="error">{errors.company}</div>
                        )}

                        <input
                            type="text"
                            name="company"
                            id="company"
                            value={this.state.company}
                            placeholder="Company"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(event) => this.handleInputChange(event)}
                        />
                    </div>

                    <div className="form-field no-label-field">
                        <label htmlFor="password">Address:</label>

                        {!!errors.address && (
                            <div className="error">{errors.address}</div>
                        )}

                        <input
                            type="text"
                            name="address"
                            id="address"
                            value={this.state.address}
                            placeholder="Address"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(event) => this.handleInputChange(event)}
                        />
                    </div>
                    <div className="form-field no-label-field">
                        <label htmlFor="address_2">Address 2:</label>

                        {!!errors.address_2 && (
                            <div className="error">{errors.address_2}</div>
                        )}

                        <input
                            type="text"
                            name="address_2"
                            id="address_2"
                            value={this.state.address_2}
                            placeholder="Address Line 2"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(event) => this.handleInputChange(event)}
                        />
                    </div>

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="city">City:</label>

                            {!!errors.city && <div className="error">{errors.city}</div>}

                            <input
                                type="text"
                                name="city"
                                id="city"
                                value={this.state.city}
                                placeholder="City"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>

                        <div className="form-field no-label-field half-field">
                            <label htmlFor="postal">Postal:</label>

                            {!!errors.postal && (
                                <div className="error">{errors.postal}</div>
                            )}

                            <input
                                type="text"
                                name="postal"
                                id="postal"
                                value={this.state.postal}
                                placeholder="Postal"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>
                    </div>

                    {locationsError ? (
                        <div className="error top-margin">{locationsError}</div>
                    ) : locationsLoading ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>
                    ) : (
                        <div className="floated-field-container">
                            <div className="form-field no-label-field half-field">
                                <label htmlFor="country">Country:</label>

                                {!!errors.country && (
                                    <div className="error">{errors.country}</div>
                                )}

                                <Select
                                    classNamePrefix="react-select"
                                    name={`country`}
                                    placeholder="Country"
                                    value={countries.filter(
                                        ({ id }) => id === this.state.country
                                    )}
                                    onChange={(selection) =>
                                        this.updateSelectedCountry(selection)
                                    }
                                    isClearable={false}
                                    getOptionLabel={({ title }) => title}
                                    getOptionValue={({ id }) => id}
                                    options={countries}
                                />
                            </div>

                            <div className="form-field no-label-field half-field">
                                <label htmlFor="province">Province:</label>

                                {!!errors.province && (
                                    <div className="error">{errors.province}</div>
                                )}

                                <Select
                                    classNamePrefix="react-select"
                                    name={`province`}
                                    placeholder={
                                        this.state.country === 'CA' ? 'Province' : 'State'
                                    }
                                    value={provinces.filter(
                                        ({ abbreviation }) =>
                                            abbreviation === this.state.province
                                    )}
                                    onChange={(selection) =>
                                        this.updateSelectedProvince(selection)
                                    }
                                    isClearable={false}
                                    getOptionLabel={({ name }) => name}
                                    getOptionValue={({ abbreviation }) => abbreviation}
                                    options={provinces}
                                />
                            </div>
                        </div>
                    )}

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="phone">Phone:</label>

                            {!!errors.phone && (
                                <div className="error">{errors.phone}</div>
                            )}

                            <NumberFormat
                                value={this.state.phone}
                                format="### ### ####"
                                mask="_"
                                placeholder="Phone number"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onValueChange={(e) => this.handleNumberChange('phone', e)}
                            />
                        </div>
                    </div>

                    <div className="btn_container">
                        {!!errors.general && (
                            <div className="error">{errors.general}</div>
                        )}

                        {notGuest && (
                            <div className="form-field half-field">
                                <div className="custom-label checkbox-label no-bottom-margin">
                                    <input
                                        type="checkbox"
                                        id="save_address"
                                        name="save_address"
                                        value="1"
                                        checked={
                                            !!this.state.save_address &&
                                            this.state.save_address
                                        }
                                        onChange={(e) => this.handleCheckboxClick(e)}
                                    />
                                    <label htmlFor="save_address">Save Address</label>
                                </div>
                                .{' '}
                            </div>
                        )}

                        <button
                            className={
                                'btn submit-btn' +
                                (this.props.billingCheckInProgress ? ' loading' : '')
                            }
                            disabled={this.props.billingCheckInProgress}
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            <span>Use Address</span>
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        billing: state.checkout.billing,
        errors: state.checkout.billingErrors,
        countries: state.locations.countries,
        default_country: state.locations.default_country,
        provinces: state.locations.provinces,
        locationsLoading: state.locations.isLoading,
        locationsError: state.locations.error,
        billingCheckInProgress: state.checkout.billingCheckInProgress,
        isStore: state.checkout.isStore,
        isPickup: state.cart.is_pickup,
        shippingData: state.checkout.shipping,
        allowPickupTimes: state.checkout.delivery.allow_pickup_times,
    };
};

export default connect(
    mapStateToProps,
    {
        getLocations,
        getProvinces,
        setBilling,
        setSavedBillingAddress,
        setActiveCheckoutSection,
    }
)(BillingSection);



// WEBPACK FOOTER //
// ./src/components/checkout/billing/BillingSection.js